module.exports = __webpack_public_path__ + "fe7f5e3eb25f8a65d0cc9e140509385d.MP3";